export enum SupplierTemplateSearchTypes {
    VendorName = "VendorName",
    VendorNumber = "VendorNumber",
    ProductLineName = "ProductLineName",
    ProductLineNumber = "ProductLineNumber",
    TemplateId = "TemplateId"
};